import React, { Component } from 'react';

import { CustomTableHeadRow } from './HeadRow.styles';

class HeadRow extends Component {
  render() {
    const { clickable } = this.props;
    return <CustomTableHeadRow clickable={clickable ? 1 : 0}>{this.props.children}</CustomTableHeadRow>;
  }
}

export default HeadRow;
